export default __webpack_public_path__ + "static/media/AMooreThesis.117ee157.zip";